// extracted by mini-css-extract-plugin
export default {"ReadMore":"_3LDaw8DLvk4Ph9iB-P89BT","text":"_2_xjODNfR2XTMSjFUTbQF4","desc":"_2A0jI_8JrRmOTCQozUvjlH","hidden":"_1QU1JFXlD8V-m35E4LZ4Nm"};